const CanViewPublishers = (formData) => (
  formData && ! formData.internal_only
);

export default CanViewPublishers;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/CanViewPublishers.tsx